"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueLinkCard = void 0;
const getLastComment_1 = __importDefault(require("@opsbase/lib-conversation/helpers/getLastComment"));
const Flag_1 = require("@opsbase/lib-issue/Flag");
const IssueStatus_1 = require("@opsbase/lib-issue/IssueStatus");
const lib_pages_1 = __importDefault(require("@opsbase/lib-pages"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useIssueFindById_1 = __importDefault(require("@opsbase/react-gql-hooks/issue/useIssueFindById"));
const LinkCard_1 = __importDefault(require("@opsbase/web-cards/LinkCard"));
const IssueIcon_1 = __importDefault(require("@opsbase/web-icons/icons/IssueIcon"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const react_1 = __importStar(require("react"));
require("react-quill/dist/quill.snow.css");
function IssueLinkCard({ answer }) {
    const { goTo } = (0, useNav_1.default)();
    const { settings } = (0, useSelf_1.default)();
    const issueId = answer === null || answer === void 0 ? void 0 : answer.issueId;
    const { data: issue } = (0, useIssueFindById_1.default)({ variables: { id: issueId } });
    const handleClickIssue = (0, react_1.useCallback)(() => {
        goTo(lib_pages_1.default.ISSUES_VIEW, { id: issueId });
    }, [goTo, issueId]);
    return (0, react_1.useMemo)(() => {
        var _a;
        if (!issue || !issueId)
            return null;
        return (react_1.default.createElement(LinkCard_1.default, { tags: [settings.getIssueTypeTitle(issue === null || issue === void 0 ? void 0 : issue.type)], watermark: IssueIcon_1.default, watermarkColor: (0, Flag_1.flagColor)(issue === null || issue === void 0 ? void 0 : issue.flag), title: issue === null || issue === void 0 ? void 0 : issue.title, description: (_a = (0, getLastComment_1.default)(issue.conversation)) === null || _a === void 0 ? void 0 : _a.title, statusColor: (0, IssueStatus_1.issueStatusColor)(issue === null || issue === void 0 ? void 0 : issue.status), onClick: handleClickIssue }));
    }, [handleClickIssue, issue, issueId, settings]);
}
exports.IssueLinkCard = IssueLinkCard;
exports.default = IssueLinkCard;
